import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

interface InviteTeamMembersProps {
  onSendInvitations: (emails: string[]) => Promise<void>;
  isAdmin: boolean;
}

export const InviteTeamMembers: React.FC<InviteTeamMembersProps> = ({
  onSendInvitations,
  isAdmin,
}) => {
  const [emailInputs, setEmailInputs] = useState<string[]>(["", "", ""]);
  const [sending, setSending] = useState(false);

  const addEmailInput = () => {
    setEmailInputs((prev) => [...prev, ""]);
  };

  const updateEmailInput = (index: number, value: string) => {
    setEmailInputs((prev) =>
      prev.map((email, i) => (i === index ? value : email)),
    );
  };

  const hasValidEmails = emailInputs.some((email) => email.trim() !== "");

  const handleSend = async () => {
    const validEmails = emailInputs.filter((email) => email.trim() !== "");
    if (validEmails.length === 0) return;

    setSending(true);
    try {
      await onSendInvitations(validEmails);
      setEmailInputs(["", "", ""]);
    } catch (error) {
      console.error("Failed to send invitations:", error);
    } finally {
      setSending(false);
    }
  };

  if (!isAdmin) {
    return (
      <div className="member-restricted-access">
        <p>
          Team member invitations are restricted to organization administrators.
        </p>
      </div>
    );
  }

  return (
    <div className="content invitations">
      <div className="invite-inputs">
        {emailInputs.map((email, index) => (
          <div key={index} className="invite-input-row">
            <span className="p-input-icon-left">
              <i className="pi pi-envelope" />
              <InputText
                value={email}
                placeholder="Enter email address"
                onChange={(e) => updateEmailInput(index, e.target.value)}
              />
            </span>
          </div>
        ))}
      </div>
      <div className="invitations-actions">
        <div className="invitations-actions-addNew" onClick={addEmailInput}>
          <i className="pi pi-plus"></i>Add another
        </div>
        <Button
          label="Send invites"
          onClick={handleSend}
          disabled={!hasValidEmails || sending}
          loading={sending}
          className="send-invites-button"
        />
      </div>
      <div className="invitations-info">
        <p>
          Only registered members can be invited. Ask them to sign up first if
          they don’t have an account.
        </p>
      </div>
    </div>
  );
};
